import React, { useEffect, useState } from 'react';
import ReviewForm from '@base/review/ReviewForm';
import styles from './index.module.less';
import { IUseEarlyAccessResults } from '@pro/activity/testerClub/useEarlyAccessResults'
import cn from 'classnames';
import { HtmlRender } from '@base/snippets/HtmlRender'
import { useTrans } from 'base/utils/i18n';
import { reviewUploadValidator } from '@pro/activity/testerClub/utils';

type IProps = {
    results: IUseEarlyAccessResults
    className?: string
}

const FilesUploadError = {
    image: 'web_test_club_review_form_tip_2',
    video: 'web_test_club_review_form_tip_3',
}

const ReviewFormContent: React.FC<IProps> = (props) => {
    const { className, results } = props;

    const { orderId = '' } = results?.resultsData || {}
    const { t } = useTrans();

    return (
        <div className={cn(className)}>

            <div className={styles['rules-container']}>

                <div className={styles['msg-warp']}>

                    <HtmlRender
                        html={t('web_early_access_review_tips')}
                    />

                </div>
            </div>

            <ReviewForm
                orderId={orderId}
                className={styles['form-wrap']}
                pointsModalClassName={styles['points-modal']}
                showLabel={false}
                submitBtnAffixTarget={() => document.getElementById('js-review-form-warp')}
                formProps={{
                    validateTrigger: ['onSubmit'],
                }}
                formItemRules={{
                    'review': [{
                        validator: (rule, value) => {
                            if (!value || value.trim().length < 300) {
                                return Promise.reject(t('web_test_club_review_form_tip_1'),);
                            }
                            return Promise.resolve();
                        }
                    }],
                    'files': [
                        {
                            validator: (rule, value) => {
                                const _validator = reviewUploadValidator(value)
                                if (typeof _validator === 'boolean') {
                                    return Promise.resolve()
                                }
                                return Promise.reject(t(FilesUploadError[_validator]))
                            }
                        },
                    ]
                }}
            />
        </div>
    );
};

export default ReviewFormContent